<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-image"><a id="page_v"></a><img alt="Image" height="171" src="images/f000v-01.jpg" width="220"/></p>
<h2 class="h2c">CONTENTS</h2>
<p class="toc-front"><a href="#/xhtml/preface"><em>Preface</em></a></p>
<p class="toc-front"><a href="#/xhtml/ack"><em>Acknowledgments</em></a></p>
<div class="chap">
<p class="toc-chap"><a href="#/xhtml/ch01">     <strong>I</strong>    The Medieval Ethno-Religious Frontier</a></p>
<p class="toc-chap"><a href="#/xhtml/ch02">    <strong>II</strong>    Kievan <em>Rus</em>’ and the Steppe</a></p>
<p class="toc-chap"><span href="#/xhtml/ch03" title="Link target outside of Sample">   <strong>III</strong>    The Mongol Empire and the Golden Horde</span></p>
<p class="toc-chap"><span href="#/xhtml/ch04" title="Link target outside of Sample">   <strong>IV</strong>    The Mongol Administration of Russia</span></p>
<p class="toc-chap"><span href="#/xhtml/ch05" title="Link target outside of Sample">    <strong>V</strong>    The Mongol Role in Russian Politics</span></p>
<p class="toc-chap"><span href="#/xhtml/ch06" title="Link target outside of Sample">   <strong>VI</strong>    The Russian “Theory” of Mongol Rule</span></p>
<p class="toc-chap"><span href="#/xhtml/ch07" title="Link target outside of Sample">  <strong>VII</strong>    Economic and Demographic Consequences</span></p>
<p class="toc-chap"><span href="#/xhtml/ch08" title="Link target outside of Sample"><strong>VIII</strong>    The Mongols and the Muscovite Autocracy</span></p>
<p class="toc-chap"><span href="#/xhtml/ch09" title="Link target outside of Sample">   <strong>IX</strong>    The Mongols and Russian Society</span></p>
<p class="toc-chap"><span href="#/xhtml/ch10" title="Link target outside of Sample">    <strong>X</strong>    Cultural Life</span></p>
<p class="toc-chap"><span href="#/xhtml/ch11" title="Link target outside of Sample">   <strong>XI</strong>    Conclusion</span></p>
</div>
<p class="toc-backa"><span href="#/xhtml/notes" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="toc-back"><span href="#/xhtml/bib" title="Link target outside of Sample"><em>Bibliography</em></span></p>
<p class="toc-back"><span href="#/xhtml/index" title="Link target outside of Sample"><em>Index</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4a62a7a3